module.exports = __webpack_public_path__ + "/static/airquality.mp4";